import { z } from 'zod';
/**
 * Request body for POST /auth/firebase
 */
export const firebaseAuthRequestSchema = z.object({
    idToken: z.string().min(1, 'idToken is required'),
    workspaceSlug: z.string().optional(),
});
export const acceptInviteRequestSchema = z.object({
    inviteId: z.string().uuid('inviteId must be a valid UUID'),
});
/**
 * Application user returned after successful auth
 *
 * Uses uuid (not internal id) for all external references.
 */
export const appUserSchema = z.object({
    uuid: z.string(),
    email: z.string(),
    displayName: z.string(),
    givenName: z.string().nullable(),
    familyName: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    accountStatus: z.enum(['active', 'suspended']),
    userType: z.enum(['regular', 'bootstrap', 'system']),
    emailVerified: z.boolean(),
    authProvider: z.string(),
    lastLoginAt: z.date().nullable(),
});
/**
 * Successful response from POST /auth/firebase
 */
export const firebaseAuthResponseSchema = z.object({
    user: appUserSchema,
});
//# sourceMappingURL=auth.js.map